import styled from '@emotion/styled';

export const Label = styled.p`
    color: ${({ theme }) => theme.secondaryText};
    font-weight: 500;
    font-size: 1rem;
    line-height: 1.5rem;
    margin: 2rem 0 0.375rem 0;
`;

export const Text = styled.p`
    font-weight: 700;
    font-size: 1.75rem;
    line-height: 2.25rem;
    margin: 0.375rem 0;
`;
